import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

/**
 * Default navigation links for logged-in users
 * @param {Function} handleLogout - Logout handler function
 * @param {Function} router - Next.js router instance
 * @returns {Array} Navigation link configuration
 */
export const getAuthenticatedNavLinks = (handleLogout, router) => [
  { 
    label: "Profile", 
    icon: <AccountCircleIcon />, 
    to: "/account/profile",
    onClick: () => router.push("/account/profile")
  },
  { 
    label: "Logout", 
    icon: <ExitToAppIcon />, 
    onClick: handleLogout 
  },
];

/**
 * Default navigation links for logged-out users
 * @returns {Array} Navigation link configuration
 */
export const getUnauthenticatedNavLinks = () => [
  { 
    label: "Log in", 
    to: "/login" 
  },
  {
    label: "Sign up",
    to: "/signup",
    variant: "contained",
    color: "primary",
  },
];

/**
 * Extended navigation links for authenticated users (for drawer/menu)
 * @param {Function} handleLogout - Logout handler function
 * @param {Function} router - Next.js router instance
 * @returns {Array} Extended navigation link configuration
 */
export const getExtendedAuthNavLinks = (handleLogout, router) => [
  {
    label: "Dashboard",
    icon: <DashboardIcon />,
    to: "/dashboard",
    onClick: () => router.push("/dashboard")
  },
  {
    label: "Songs",
    icon: <LibraryMusicIcon />,
    to: "/songs",
    onClick: () => router.push("/songs")
  },
  {
    label: "Profile",
    icon: <AccountCircleIcon />,
    to: "/account/profile",
    onClick: () => router.push("/account/profile")
  },
  { divider: true }, // Visual separator
  {
    label: "Logout",
    icon: <ExitToAppIcon />,
    onClick: handleLogout
  },
];

/**
 * Validates a navigation link configuration
 * @param {Object} link - Navigation link object
 * @returns {boolean} Whether the link is valid
 */
export const isValidNavLink = (link) => {
  if (link.divider) return true;
  return link.label && (link.to || link.onClick);
};

/**
 * Filters navigation links based on user permissions or conditions
 * @param {Array} links - Array of navigation links
 * @param {Function} filterFn - Filter function
 * @returns {Array} Filtered navigation links
 */
export const filterNavLinks = (links, filterFn) => {
  return links.filter(filterFn);
};
